import React, { useEffect, useReducer, useState } from 'react'
import { message, Modal, Skeleton, Spin, Tooltip, Upload } from 'antd'
import Api, { makeRequest } from 'api'
import { useAuthSelector } from 'store/authSlice/authReducer'
import {
  MdInfoOutline,
  MdListAlt,
  MdOutlineMessage,
  MdOutlineSimCardDownload,
  MdOutlineUploadFile,
  MdPersonAddAlt,
} from 'react-icons/md'
import { searchDonnorRows } from 'utils'
import { AiOutlineMergeCells } from 'react-icons/ai'
import { config } from 'configs'
import { Can } from 'permissions'
import { AddCommunityMemberModal } from 'components/common'
import { DonorList } from './DonorList'
import { MessageForm } from './MessageForm'
import { UploadStatisticModal } from './uploadStatisticModal'
import { MergeDonorModal } from './MergeDonorModal'
import { DownloadInstructionModal } from './DownloadInstructionModal'
import { SendInvite } from './SendInvite'

const initialState = {
  get: false,
  download: false,
  downloadDonorList: false,
  upload: false,
  reminder: false,
  custom: false,
  list: false,
}
// The reducer function
function reducer(state, action) {
  switch (action) {
    case 'get':
      return {
        ...state,
        get: !state.get,
      }
    case 'download':
      return {
        ...state,
        download: !state.download,
      }
    case 'downloadDonorList':
      return {
        ...state,
        downloadDonorList: !state.downloadDonorList,
      }
    case 'upload':
      return {
        ...state,
        upload: !state.upload,
      }
    case 'reminder':
      return {
        ...state,
        reminder: !state.reminder,
      }
    case 'custom':
      return {
        ...state,
        custom: !state.custom,
      }
    case 'list':
      return {
        ...state,
        list: !state.list,
      }
    default:
      return state
  }
}

const CommunityList = ({ searchText }) => {
  const { organization: org } = useAuthSelector()
  const [loading, setLoading] = useReducer(reducer, initialState)
  const [donors, setDonors] = useState()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isInviteModalVisible, setIsInviteModalVisible] = useState(false)
  const [statisticModal, setStatisticModal] = useState(false)
  const [statisticData, setStatisticData] = useState()
  const [showMergeModal, setShowMergeModal] = useState(false)
  const [showInstructionModal, setShowInstructionModal] = useState(false)
  const [addShowModal, setAddShowModal] = useState(false)

  useEffect(() => {
    const getData = async () => {
      setLoading('get')
      try {
        getDonors(org?.id)
        setLoading('get')
      } catch (error) {
        console.log('error', error)
        setLoading('get')
      }
    }
    getData()
  }, [org])

  const getDonors = (id) => {
    setLoading('list')
    Api.get(`subscriber/donorList/${id}`)
      .then((res) => {
        setDonors(res.result)
        setLoading('list')
      })
      .catch((error) => {
        console.log('error', error)
        message.error('An Error Occured in fetching list')
        setLoading('list')
      })
  }

  const downloadFile = (data, type, filename) => {
    const blob = new Blob([data], { type: type.toString() })
    const blobURL = window.URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.download = filename
    anchor.href = blobURL
    anchor.click()
  }

  const getFile = () => {
    setLoading('download')
    Api.get('subscriber/downloadSampleFile')
      .then((res) => {
        downloadFile(res, 'application/ms-excel', 'Sample-DonorList.csv')
        setShowInstructionModal(true)
        setLoading('download')
      })
      .catch((error) => {
        console.log('error', error)
        setLoading('download')
      })
  }

  const sendReminder = (data) => {
    setIsInviteModalVisible(false)
    const list = donors
      ?.filter((item) => selectedRowKeys.includes(item.Id))
      .map((item) => ({
        Id: item.Id,
        DonorName: item.DonorName,
        DonorEmail: item.DonorEmail,
        DonorPhoneNumber: item.DonorPhoneNumber,
        DonorZipCode: item.DonorZipCode,
      }))
    const isListPresent = list.length > 0

    if (org && org.id) {
      const payload = {
        isListPresent,
        list,
        id: org.id,
        orgName: org.Name,
        message: data.message,
      }
      setLoading('reminder')
      makeRequest(
        'post',
        'subscriber/sendReminder',
        {
          organization: org.id,
        },
        payload,
      )
        .then((res) => {
          message.success(res.message)
          setSelectedRowKeys([])
          setLoading('reminder')
        })
        .catch((error) => {
          console.log('error', error)
          message.error(error?.message)
          setLoading('reminder')
        })
    } else {
      message.error('Cound not get Organization data')
    }
  }

  const sendCustom = (data) => {
    setIsModalVisible(false)
    const list = donors
      ?.filter((item) => selectedRowKeys.includes(item.Id))
      .map((item) => ({
        Id: item.Id,
        DonorName: item.DonorName,
        DonorEmail: item.DonorEmail,
        DonorPhoneNumber: item.DonorPhoneNumber,
        DonorZipCode: item.DonorZipCode,
      }))
    const isListPresent = list.length > 0
    if (org && org.id && org.Email) {
      const payload = {
        isListPresent,
        list,
        orgId: org.id,
        email: org.Email,
        ...data,
      }
      setLoading('custom')
      makeRequest(
        'post',
        'subscriber/sendCustomMessage',
        {
          organization: org?.id,
        },
        { payload },
      )
        .then((res) => {
          message.success(res.message)
          setSelectedRowKeys([])
          setLoading('custom')
        })
        .catch((error) => {
          console.log('error', error)
          message.error(error?.message)
          setLoading('custom')
        })
    } else {
      message.error('Cound not get Organization data')
    }
  }

  const onFileUpload = (file) => {
    if (org && org.id && org.Name && org.Email) {
      const data = new FormData()
      data.append('uploadfile', file)
      data.append('OrganizationId', org.id)
      data.append('OrganizationName', org.Name)
      data.append('OrganizationEmail', org.Email)
      if (file.size < 2 * 1048576) {
        setLoading('upload')
        Api.put('subscriber/uploadDonorList', data)
          .then((res) => {
            message.success(res.message)
            setLoading('upload')
            setStatisticData(res?.statusData)
            setStatisticModal(true)
            getDonors(org.id)
          })
          .catch((error) => {
            console.log('error', error)
            message.error(
              error?.response?.data?.error ||
                'File cannot be processed due to an error',
            )
            setLoading('upload')
          })
      } else {
        message.error('File size should be less than 20 MB to upload')
      }
    } else {
      message.error('Cound not get Organization data')
    }
  }

  const onDownloadDonorList = () => {
    const list = donors
      .filter((item) => selectedRowKeys.includes(item.Id))
      .map((item) => ({
        DonorName: item.DonorName,
        DonorEmail: item.DonorEmail,
        DonorPhoneNumber: item.DonorPhoneNumber,
        DonorZipCode: item.DonorZipCode,
      }))
    setLoading('downloadDonorList')
    Api.post('subscriber/downloadDonorListFile', { list })
      .then((res) => {
        downloadFile(res, 'application/ms-excel', 'My-DonorList.csv')
        setLoading('downloadDonorList')
        setSelectedRowKeys([])
      })
      .catch((error) => {
        console.log('error', error)
        setLoading('downloadDonorList')
      })
  }

  const getMergeData = () => {
    const list = donors
      ?.filter((item) => selectedRowKeys.includes(item.Id))
      .map((item) => ({
        Id: item.Id,
        DonorName: item.DonorName,
        DonorEmail: item.DonorEmail,
        DonorPhoneNumber: item.DonorPhoneNumber,
        DonorZipCode: item.DonorZipCode,
      }))

    return list
  }

  return (
    <Skeleton loading={loading.get} active paragraph={{ rows: 12 }}>
      <Can I={config.actions.edit} a={config.components.organizationCommunity}>
        <div className="t-flex t-justify-end t-items-center t-space-x-2">
          {selectedRowKeys.length > 0 && (
            <Tooltip title="Download Selected Donor List">
              {loading.downloadDonorList ? (
                <Spin />
              ) : (
                <MdListAlt
                  fontSize="1.7rem"
                  id="download"
                  className="t-text-secondary-100 t-cursor-pointer"
                  onClick={() => onDownloadDonorList()}
                />
              )}
            </Tooltip>
          )}
          <Tooltip title="Select two donors to merge">
            <AiOutlineMergeCells
              fontSize="1.7rem"
              id="merge"
              className={`t-text-secondary-100 t-cursor-pointer ${
                selectedRowKeys.length !== 2 && 't-opacity-50 t-cursor-default'
              }`}
              onClick={() =>
                selectedRowKeys.length === 2 && setShowMergeModal(true)
              }
            />
          </Tooltip>
          <Tooltip title="Add New Community Member">
            <MdPersonAddAlt
              fontSize="1.7rem"
              className="t-text-secondary-100 t-cursor-pointer"
              onClick={() => setAddShowModal(true)}
            />
          </Tooltip>
          <Tooltip title="Download Donor Template">
            {loading.download ? (
              <Spin />
            ) : (
              <MdOutlineSimCardDownload
                fontSize="1.7rem"
                id="download"
                className="t-text-secondary-100 t-cursor-pointer"
                onClick={() => getFile()}
              />
            )}
          </Tooltip>
          <Upload
            id="upload"
            customRequest={(e) => onFileUpload(e.file)}
            maxCount={1}
            showUploadList={false}
            accept=".csv"
          >
            <Tooltip title="Upload Donor List">
              {loading.upload ? (
                <Spin />
              ) : (
                <MdOutlineUploadFile
                  fontSize="1.7rem"
                  className="t-text-secondary-100 t-cursor-pointer t-mt-1"
                />
              )}
            </Tooltip>
          </Upload>
          <Tooltip title="Send Invites">
            {loading.reminder ? (
              <Spin />
            ) : (
              <MdInfoOutline
                fontSize="1.7rem"
                id="send-invites"
                className="t-text-secondary-100 t-cursor-pointer"
                onClick={() => setIsInviteModalVisible(true)}
              />
            )}
            {isInviteModalVisible && (
              <SendInvite
                show={isInviteModalVisible}
                setShow={setIsInviteModalVisible}
                organization={org}
                submit={(data) => sendReminder(data)}
              />
            )}
          </Tooltip>
          <Tooltip title="Send Message">
            {loading.custom ? (
              <Spin />
            ) : (
              <MdOutlineMessage
                fontSize="1.7rem"
                id="send-global-message"
                className="t-text-secondary-100 t-cursor-pointer"
                onClick={() => setIsModalVisible(true)}
              />
            )}
          </Tooltip>
          <Modal
            title="Message Form"
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
          >
            <MessageForm submit={(data) => sendCustom(data)} />
          </Modal>
        </div>
      </Can>
      <div>
        <DonorList
          loading={loading.list}
          data={searchDonnorRows(donors, searchText) || []}
          getData={() => getDonors(org.id)}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </div>
      <UploadStatisticModal
        isVisible={statisticModal}
        onClose={() => {
          setStatisticModal(false)
        }}
        statisticData={statisticData}
        downloadFile={downloadFile}
      />
      {showMergeModal && (
        <MergeDonorModal
          isVisible={showMergeModal}
          onClose={() => setShowMergeModal(false)}
          mergeData={getMergeData() || []}
          refresh={() => {
            setShowMergeModal(false)
            setSelectedRowKeys([])
            getDonors(org.id)
          }}
        />
      )}
      {showInstructionModal && (
        <DownloadInstructionModal
          isVisible={showInstructionModal}
          onClose={() => setShowInstructionModal(false)}
        />
      )}
      {addShowModal && (
        <AddCommunityMemberModal
          isVisible={addShowModal}
          onClose={() => setAddShowModal(false)}
          getData={() => getDonors(org.id)}
        />
      )}
    </Skeleton>
  )
}

export { CommunityList }
